<template>
  <Menu class="top-nav" mode="horizontal" theme="dark" :active-name="activeName" @on-select="go">
    <div class="site-title">
      <span> {{title}}</span>
    </div>
    <div class="top-menu">
      <MenuItem v-for="nav in navs" :name="nav.name" :key="nav.name">
      <i v-if="nav.icon" :class="nav.icon"></i>
      <span> {{nav.text}}</span>
      </MenuItem>
      <core-userprofile />
    </div>
  </Menu>
</template>

<script>
import { mapState } from "vuex"

export default {
  components: {},
  data() {
    var routes = this.$app.menus
    var navs = routes.map((t) => {
      return { name: t.name, text: t.text, icon: t.icon }
    })
    return { navs }
  },
  computed: {
    activeName() {
      return this.$route.matched[0].name
    },
    ...mapState({
      title: (state) => state.core.title,
    }),
  },
  methods: {
    go(name) {
      if (this.$route.name != name) this.$router.push({ name })
    },
  },
}
</script>
<style scoped>
.site-title {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  float: left;
  margin-left: 20px;
}

.top-nav {
  background: none;
  height: 100%;
  line-height: 50px;
}

.top-menu {
  float: right;
  margin-right: 50px;
}

.top-menu li:hover {
  background: #42495a;
}
</style>